<template>
	<please-select-utility alert-class="ma-3">
		<template v-if="!imodel.loaded">
			<v-progress-linear indeterminate/>
		</template>
		<template v-else>
			<div v-show="!isEdit">
				<v-row dense>
					<v-col>
						<v-sheet rounded elevation="2" class="pa-2 d-flex flex-wrap">
							<div>
								<base-input
									v-model="itemID" label="ID"
									clearable outlined hide-details dense flat
									size="10"
								/>
							</div>
							<v-divider vertical class="mx-2"/>
							<div>
								<model-input
									:imodel="imodel" name="custom_imot_ownership_transfers.imot_N" v-model="imot_N"
									label="Имот Номер" clearable outlined hide-details dense flat size="25"
								/>
							</div>
							<v-divider vertical class="mx-2"/>
							<session-select label="Сесия" v-model="session_id" :utility="selectedUtility"
															:izr_sess="sessionType.SESS_TYPE_REDOVNA"
															clearable outlined hide-details dense flat
															class="flex-grow-1"></session-select>

							<v-divider vertical class="mx-2"/>
							<div>
								<model-input
									:imodel="imodel" name="custom_imot_ownership_transfers.created_at" type="date"
									v-model="created_at_left" label="След"
									clearable outlined hide-details dense flat
									size="15"
								/>
							</div>
							<div>
								<model-input
									:imodel="imodel" name="custom_imot_ownership_transfers.created_at" type="date"
									v-model="created_at_right" label="Преди"
									clearable outlined hide-details dense flat
									size="15"
									class="ml-2"
								/>
							</div>
						</v-sheet>
					</v-col>
				</v-row>
				<v-toolbar flat>
					<v-toolbar-title>{{ imodel.Title }}</v-toolbar-title>
					<v-spacer />
					<v-btn @click="onAdd" dark color="primary">
						<v-icon left>mdi-plus</v-icon>
						Нов запис
					</v-btn>
				</v-toolbar>
				<List
					ref="list"
					@edit="onEdit"
					:imodel="imodel"
					:params="listParams"
					headers="id,session_id,imot_N,created_at,updated_at,CONTRACT,water_rate,heat_rate"
					hide-select
					:hide-delete="!authorization.hasRole(RolesEnum.CUSTOM_IMOT_OWNERSHIP_TRANSFER_DELETE)"
					sort-by="id"
					sort-desc
				/>
			</div>
			<div v-if="isEdit">
				<edit-column
					column
					:id="id"
					:imodel="imodel"
					:init="{utility_code:selectedUtility}"
					:data-append="{utility_code:selectedUtility}"
					:edit-button-options="{showDelete:authorization.hasRole(RolesEnum.CUSTOM_IMOT_OWNERSHIP_TRANSFER_DELETE)}"
					hiddenFields="water_rate,heat_rate,imot_N"
					disabled-fields="created_at,updated_at,utility_code"
					@edit="onEdit"
					@saveclose="onSaveClose"
					@save="onSave"
					@close="onEditCancel"
					ref="EditForm"
				>
					<template #field.session_id="{err,row,disabled}">
						<edit-input-wrapper name="session_id">
							<session-select label="Сесия" :utility="row.utility_code"
								:disabled="disabled || (id && id !== 'new')"
								:izr_sess="sessionType.SESS_TYPE_REDOVNA"
								clearable outlined hide-details dense flat
								:value="row['session_id'] || ''"
								@input="$set(row, 'session_id', $event); session_id_in_edit=$event; $emit('input', $event)"
								@change="$set(row, 'session_id', $event); $emit('change', $event)"
								:errors="err && err['session_id'] || null"
								class="flex-grow-1" />
						</edit-input-wrapper>
					</template>
					<template #after-row.session_id="{leftColStyle, rightColStyle,row,disabled}">
						<v-row key="replace-row.imot_id" no-gutters justify="center">
							<v-col class="pt-3" :style="leftColStyle">
								Имот номер
							</v-col>
							<v-col class="pa-1" :style="rightColStyle">
								<edit-input-wrapper name="imot_id">
									<imot-select
										outlined dense clearable hide-details="auto" :session="session_id_in_edit"
										search_by_imot_N="1"
										:value="row['imot_id'] || ''"
										@input="loadInitValue($event,row);$emit('input', $event)"
										:disabled="disabled || !session_id_in_edit"/>
								</edit-input-wrapper>
							</v-col>
						</v-row>
					</template>
					<template #before-row.CONTRACT="{leftColStyle, rightColStyle,row}">
						<v-row key="replace-row.CONTRACT_old" no-gutters justify="center">
							<v-col class="pt-3" :style="leftColStyle">
								Стара договорена сметка
							</v-col>
							<v-col class="pa-1" :style="rightColStyle">
								<base-input
									outlined dense
									:value="row && row['old_contract'] || ''"
									:disabled="true" />
							</v-col>
						</v-row>
					</template>
					<template #after-fields="{row,err,loading}">
						<v-row class="pt-3 mr-1" no-gutters>
							<rate-or-value-input style="width: 49.5%;"
								title="Вода" field="water_rate"
								:err="err" :row="row" :loading="loading"/>
							<rate-or-value-input style="width: 49.5%;"
								title="Отопление" field="heat_rate"
								:err="err" :row="row" :loading="loading"/>
						</v-row>
					</template>
				</edit-column>
			</div>
		</template>
	</please-select-utility>
</template>

<script>
import SelectedUtilityMixin from "@/ittijs/SelectedUtilityMixin";
import ITTIModelProvider from "@/ittijs/ITTIModelProvider";
import ModelInput from "@/ittijs/Inputs/ModelInput.vue";
import BaseInput from "@/ittijs/Inputs/BaseInput.vue";
import List from "@/ittijs/List.vue";
import {SessionType} from "@/ittijs/Nomenclatures";
import ITTIModel from "@/ittijs/ITTIModel";
import SessionSelect from "@/views/sessions/SessionSelect.vue";
import IndexMixin from "@/ittijs/IndexMixin";
import EditColumn from "@/ittijs/EditColumn.vue";
import PleaseSelectUtility from "@/ittijs/components/PleaseSelectUtility.vue";
import RouteSyncMixin from "@/ittijs/RouteSyncMixin";
import ThrowMeMixin from "@/ittijs/ThrowMeMixin";
import RateOrValueInput from "@/views/custom_imot_ownership_transfer/RateOrValueInput.vue";
import ImotSelect from "@/views/imot/ImotSelect.vue";
import EditInputWrapper from "@/ittijs/Inputs/EditInputWrapper.vue";
import {RolesEnum} from "@/ittijs/Authorization";

const Model = class extends ITTIModel {
	constructor() {
		super('CustomImotOwnershipTransfer');
	}
}

const imodel = ITTIModelProvider.getModel(Model);

export default {
	components: {
		EditInputWrapper,
		ImotSelect,
		RateOrValueInput,
		PleaseSelectUtility,
		EditColumn,
		List,
		SessionSelect,
		ModelInput,
		BaseInput,
	},
	mixins: [
		SelectedUtilityMixin,
		IndexMixin,
		RouteSyncMixin({
			utility: 'selectedUtility',
		}),
		ThrowMeMixin,
	],
	inject: ['authorization'],
	props: [
		'utility',
	],
	computed: {
		RolesEnum() {
			return RolesEnum
		},
		listParams(){
			return {
				id: this.itemID,
				utility: this.selectedUtility,
				session_id: this.session_id,
				imot_N: this.imot_N,
				created_at_left: this.created_at_left,
				created_at_right: this.created_at_right,
			};
		},
	},
	data(){
		return {
			sessionType: SessionType,
			imodel: imodel,
			created_at_left: null,
			created_at_right: null,
			imot_N: null,
			session_id: null,
			session_id_in_edit: null,
			itemID: null,
			is_heat_rate_value: false,
			is_water_rate_value: false,
		}
	},

	methods: {
		loadInitValue(imot_id, row){
			if(!imot_id){
				return;
			}
			imodel
				.getRow({
					utility_code: this.selectedUtility,
					session_id: this.session_id_in_edit,
					imot_id: imot_id,
				})
				.then((res) => {
					for (const key in row) {
						if(row[key] === res[key]) {
							continue;
						}
						this.$set(row, key, res[key]);
					}
					for (const key in res) {
						if(row[key] === res[key]) {
							continue;
						}
						this.$set(row, key, res[key]);
					}
				})
				.catch((err) => {
						this.throwMe(err);
				})
			;
		}
	}
}
</script>